const API = `${window.location.origin}/api`;

export const downloadDocument = (id) => {
    const token = localStorage.getItem('access_token') || '';
    const a = document.createElement('a');
    a.href = `${API}/documents/${id}?download=1&token=${encodeURIComponent(token)}`;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
};
